import { render, staticRenderFns } from "./BrandLogoLoader.vue?vue&type=template&id=4972e4f4&scoped=true"
import script from "./BrandLogoLoader.vue?vue&type=script&lang=js"
export * from "./BrandLogoLoader.vue?vue&type=script&lang=js"
import style0 from "./BrandLogoLoader.vue?vue&type=style&index=0&id=4972e4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972e4f4",
  null
  
)

export default component.exports